export const wantjob = {
  data: [{
    title: '高级软件工程师求职',
    tags: '计算机科学专业硕士，5年开发经验，精通Java和Python',
    public: "张先生",
    mobile: "15760218745",
    fee: '30,000元/月',
    imgs: [`/img/招聘信息/1.jpg`, `/img/招聘信息/part-00219-4167.jpg`, `/img/招聘信息/part-00399-2542.jpg`],
    description: `1、有大型分布式、高并发、高负载、高可用性架构经验和实施能力
2、优秀的业务理解能力、分析解决问题和沟通能力，勇于解决难题
3、具有平台化、产品化系统建设经验的优先考虑
4、具有交易业务研发背景，具有业界友商交易相关系统研发经历和深入了解的优先考虑
`
  }, {
    title: '市场营销经理求职',
    tags: '市场营销专业本科，8年工作经验，擅长品牌推广',
    public: "李女士",
    mobile: "18228106539",
    fee: '25,000元/月',
    imgs: [`/img/招聘信息/2.jpg`, `/img/招聘信息/u=74824722,3081946465&fm=253&fmt=auto&app=120&f=JPEG.webp`, `/img/招聘信息/u=156860803,3365685630&fm=253&fmt=auto&app=138&f=JPEG.webp`],
    description: `1.负责信用卡及个人消费贷的营销推广；
2.负责成都地区消费场景的搭建及获客；
3.负责营销线索落地转化，线上/线下方式相结合。
`
  }, {
    title: '行政助理求职',
    tags: '行政管理专业大专，3年工作经验，细心负责',
    public: "王小姐",
    mobile: "13082051782",
    fee: '7,000元/月',
    imgs: [`/img/招聘信息/3.jpg`, `/img/招聘信息/u=176013440,3456202736&fm=253&fmt=auto&app=138&f=JPEG.webp`, `/img/招聘信息/u=201258226,3624255166&fm=253&fmt=auto&app=138&f=JPEG.webp`],
    description: `1、负责公司资产的管理工作；
2、负责公司各类物资的采购。
3、处理公司行政内务工作。
4、重要节日重点客户通知，维系客户关系。
`
  }, {
    title: '产品经理求职',
    tags: '工商管理专业本科，5年产品管理经验',
    public: "赵先生",
    mobile: "13181089456",
    fee: '20,000元/月',
    imgs: [`/img/招聘信息/4.jpg`, `/img/招聘信息/u=211672845,3371108726&fm=253&fmt=auto&app=138&f=JPEG.webp`, `/img/招聘信息/u=272393190,3162051220&fm=253&fmt=auto&app=138&f=JPEG.webp`],
    description: `1.能使用Axure、Xmind、Office、飞书等软件设计产品原型、绘制流程、撰写文档
2.爱钻研、求知欲强、思维缜密，有强迫症者优先
3.有较强沟通力、学习力、理解力、抗压力
4.计算机、软件工程类理工科优先
`
  }, {
    title: '财务经理求职',
    tags: '财务管理专业本科，10年财务工作经验，持有CPA证书',
    public: "刘女士",
    mobile: "15682013602",
    fee: '28,000元/月',
    imgs: [`/img/招聘信息/5.jpg`, `/img/招聘信息/u=277179142,2487756583&fm=253&fmt=auto&app=138&f=JPEG.webp`, `/img/招聘信息/u=377944184,2643044509&fm=253&fmt=auto&app=138&f=JPEG.webp`],
    description: `1、3-4年财务工作经验，2年以上财务经理/主管的经历和团队管理经验优先；
2、熟悉国家财务相关政策、国家金融政策、企业财务制度及流程、精通相关财税法律法规；
3、较强的成本管理、风险控制和财务分析的能力；
4、良好的组织、协调、沟通能力，能承受工作压力；
5、认同企业文化、有责任心，敢于承担责任，执行力强
`
  }, {
    title: 'UI设计师求职',
    tags: '设计专业本科，4年UI设计经验，精通Sketch和Figma',
    public: "孙先生",
    mobile: "13382067813",
    fee: '18,000元/月',
    imgs: [`/img/招聘信息/6.jpg`, `/img/招聘信息/u=1120444911,2156865308&fm=253&fmt=auto&app=138&f=JPEG.webp`, `/img/招聘信息/u=1348185815,1041048939&fm=253&fmt=auto&app=138&f=JPEG.webp`],
    description: `1.做过TOB端的行业，有企业内部系统类或者企业产品（HR/财务/IM）的PC端，移动端设计经验，
2.有独立思考能力，逻辑性强，能够熟练使用sketch；
3.能配合开发实现设计效果，保证设计还原度；
4.具备简单的交互设计能力，能够适应较快的工作节奏；
`
  }, {
    title: '人力资源经理求职',
    tags: '人力资源管理专业本科，8年HR经验',
    public: "周小姐",
    mobile: "15382092564",
    fee: '22,000元/月',
    imgs: [`/img/招聘信息/7.jpg`, `/img/招聘信息/u=1469904030,2091461171&fm=253&fmt=auto&app=138&f=JPEG.webp`, `/img/招聘信息/u=1703904212,2850236471&fm=253&fmt=auto&app=138&f=JPEG.webp`],
    description: `1、有较强的执行力和管理能力；有较好的沟通和协调能力；具有较强的文案策划能力；
2、形象好，气质佳，有亲和力，有较强的交际能力；
3、做事细心，条理清晰，学习接受能力强，能吃苦耐劳；
4、能熟练运用office等办公软件；熟悉互联网；
`
  }, {
    title: '运营专员求职',
    tags: '电子商务专业本科，3年电商运营经验',
    public: "吴先生",
    mobile: "18082078931",
    fee: '10,000元/月',
    imgs: [`/img/招聘信息/8.jpg`, `/img/招聘信息/u=1776472054,2521701298&fm=253&fmt=auto&app=138&f=JPEG.webp`, `/img/招聘信息/u=1970873356,3655029514&fm=253&fmt=auto&app=138&f=JPEG.webp`],
    description: `1. 负责信息流广告投放，熟悉巨量、快手、MP(广点通)平台的投放规则;
2.制定广告创意，优化广告素材，对投放效果进行数据跟踪及效果分析，对投放结果负责,保证消耗回收避免造成损失;
3.分析账户数据整理与分析，制作合理化优化方案与策略，扩大投放规模，根据对素材理解同步沟通素材产出部门，及时跟进素材质量;
`
  }, {
    title: '售前工程师求职',
    tags: '通信工程专业本科，5年售前支持经验',
    public: "何女士",
    mobile: "13882514726",
    fee: '16,000元/月',
    imgs: [`/img/招聘信息/9.jpg`, `/img/招聘信息/u=2649349709,958318556&fm=253&fmt=auto&app=138&f=JPEG.webp`, `/img/招聘信息/u=2816532083,2350493215&fm=253&fmt=auto&app=138&f=JPEG.webp`],
    description: `1.反应敏捷，具有较强的表达能力及沟通协调能力；
2.亲和力强，具有良好的客户服务意识；
3.有责任心，有较强的抗压能力；
4.有团队协作精神，勇于挑战新事物。
`
  }, {
    title: '客户服务专员求职',
    tags: '客户服务专业大专，2年客服工作经验',
    public: "韩先生",
    mobile: "13982145837",
    fee: '8,000元/月',
    imgs: [`/img/招聘信息/10.jpg`, `/img/招聘信息/u=3744154589,3120568814&fm=253&fmt=auto&app=138&f=JPEG.webp`, `/img/招聘信息/u=4168017730,397583858&fm=253&fmt=auto&app=138&f=JPEG.webp`],
    description: `1、对接业务部门，根据实际业务情况设计埋点体系，保障埋点质量；
2、结合业务需求及底层数据协助数仓同事进行宽表设计;
3、分析流量、活动、订单等核心数据，形成可视化报表；
`
  }, {
    title: '数据分析师求职',
    tags: '统计学专业本科，3年数据分析经验，精通SQL和R',
    public: "陈小姐",
    mobile: "15782201648",
    fee: '18,000元/月',
    imgs: [`/img/招聘信息/11.jpg`, `/img/招聘信息/u=4226094118,3511154727&fm=253&fmt=auto&app=138&f=JPEG.webp`],
    description: `1.服从安排积极进取，良好心态
2.普通话标准有良好的沟通能力
3.能熟练运用office等办公软件；熟悉互联网
`
  }, {
    title: '网络安全工程师求职',
    tags: '信息安全专业本科，5年网络安全经验，持有CISSP证书',
    public: "杨先生",
    mobile: "13510928743",
    fee: '25,000元/月',
    imgs: [`/img/招聘信息/12.jpg`, `/img/招聘信息/u=4294848877,2722984713&fm=253&fmt=auto&app=138&f=JPEG.webp`],
    description: `1.具备网络证书，华三NE，华为NP，思科初级工程师证书
2,熟悉掌握数通、无线网络技术及弱电工程。
3,具有良好的沟通和执行力，具备较强的学习能力。
4.具有良好的服务意识、有责任心，能承受较大的工作压力。
`
  }]
}